module.exports = __webpack_public_path__ + "media/images/pictograms/pic4-8d980f7132831903456d1c5c41bf8f5e.png";